import { InfoCircleOutlined } from '@ant-design/icons'
import { Typography, Modal } from 'antd'
const { Title, Paragraph } = Typography

const InfoModal = ({ text, title, info, children }) => {
  function showModal() {
    Modal.info({
      icon: <InfoCircleOutlined />,
      closable: true,
      maskClosable: true,
      content: (
        <>
          <Title level={3}>{title}</Title>
          <Paragraph className="paragraph-s">
            {info}
            {children}
          </Paragraph>
        </>
      ),
      footer: null,
    })
  }

  return (
    <Paragraph className="info">
      <span onClick={showModal} className="show-on-desktop">
        {text}
      </span>
      <InfoCircleOutlined onClick={showModal} />
    </Paragraph>
  )
}

export default InfoModal
